module.exports = __webpack_public_path__ + "media/images/features/7/og-image-9270e1bb50f1bf2895de9c81ad1e2ea3.jpg";